export default "__VITE_ASSET__rY1n9knddGqehhNPLmcULg__"